import { orgSelectors } from 'ducks/orgs'
import { HardwareSupplierFilterKeyType } from 'opensolar-common'
import { useSelector } from 'react-redux'
import { useSupplierConfig } from './useSupplierConfig'

export const useSupplierCurrencySymbol: (supplier: HardwareSupplierFilterKeyType | undefined) => string = (
  supplier
) => {
  const supplierConfig = useSupplierConfig(supplier)
  const currencySymbolFromOrg = useSelector(orgSelectors.getCurrencySymbolFromOrg)
  return supplierConfig?.currencySymbol ?? currencySymbolFromOrg
}
